// 将GTM时区转化为 olsondb 格式
const olsondb = (timezone) => {
  let olsondbList = {
    "-10": "Pacific/Honolulu",
    "-9": "America/Juneau",
    "-8": "America/Los_Angeles",
    "-7": "America/Phoenix",
    "-6": "America/Chicago",
    "-5": "America/Bogota",
    "-4": "America/Caracas",
    "-3": "America/Argentina/Buenos_Aires",
    "0": "Etc/UTC",
    "1": "Europe/Zurich",
    "2": "Europe/Vilnius",
    "3": "Europe/Moscow",
    "4": "Asia/Muscat",
    "5": "Asia/Ashkhabad",
    "5.5": "Asia/Kolkata",
    "5.75": "Asia/Kathmandu",
    "6": "Asia/Almaty",
    "7": "Asia/Jakarta",
    "8": "Asia/Hong_Kong",
    "9": "Asia/Seoul",
    "9.5": "Australia/Adelaide",
    "10": "Australia/Melbourne",
    "11": "Pacific/Pohnpei",
    "12": "Pacific/Auckland",
    "12.75": "Pacific/Chatham",
    "13": "Pacific/Fakaofo",
  };
  return olsondbList[timezone] || "Australia/Melbourne";
}
const resolutionFormat = (resolution, name, to) => {
  let minutes = resolution;
  let requestPeriod = 'MI'+resolution;
  if (resolution.includes('D')) {
    if (resolution.length < 2) resolution = '1' + resolution;
    minutes = parseInt(resolution) * 24 * 60;
    requestPeriod = 'D1';
  } else if (resolution.includes('W')) {
    if (resolution.length < 2) resolution = '1' + resolution;
    minutes = parseInt(resolution) * 24 * 60 * 7;
    requestPeriod = "W1";
  } else if (resolution.includes('M')) {
    if (resolution.length < 2) resolution = '1' + resolution;
    minutes = parseInt(resolution) * 24 * 60 * 30;
    requestPeriod = "MO1";
  } else {
    if (resolution / 60 >= 1) {
      requestPeriod = "H" + (resolution / 60);
    }
  }

  let from = null;
  if (to) {
    from = to - 200 * minutes * 60;
    if (resolution.includes('M') || resolution.includes('W')) { // 周线月线控制条数，时间超出规定范围, ws报错
      from = to - 50 * minutes * 60;
    }
  }
  return {
    minutes,
    from,
    to,
    requestPeriod,
  };
};

// 其它方法已删除 想要获取详细信息请查看官方文档
class DataFeeds {
  constructor(store) {
    this.store = store;
    this.ws = store.ws;
  }
  onReady(callback) {
    const defaultConfiguration = {
      symbols_type: [],
      supported_resolutions: ['1', '15','30', '60','1D', '1W','1M'],
      supports_marks: true,
      supports_timescale_marks: false,
      supports_time: false
    };

    callback(defaultConfiguration);
  }

  getBars(symbolInfo, resolution, rangeStartDate, rangeEndDate, onDataCallback, onErrorCallback, firstDataRequest) {
    //赋值回调
    if (firstDataRequest) {
      this.store.to = null;
      this.store.onDataCallback = onDataCallback;
    }
    const to = this.store.to || rangeEndDate;
    const reso = resolutionFormat(resolution, symbolInfo.name, to);
    this.store.to = reso.from;

    this.store.firstDataRequest = firstDataRequest;
    this.store.sub = reso.req;
    this.store.ticker = symbolInfo.name;

    // lsj 添加k线历史数据
    this.getPeriodKlines(
      resolutionFormat(resolution, symbolInfo.name, null).requestPeriod,
      firstDataRequest
    );
  }

  subscribeBars(symbolInfo, resolution, onRealTimeCallback, listenerGUID, onResetCacheNeededCallback) {
    this.store.onRealTimeCallback = onRealTimeCallback;
  }

  unsubscribeBars() {}

  resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
    const newSymbol = Object.assign(
      {},
      {
        timezone: olsondb(this.store.localTimezone),
        minmov: 1,
        minmov2: 0,
        pointvalue: 1,
        session: "24x7", //交易时间段
        has_seconds: false,
        has_daily: true,
        has_weekly_and_monthly: true,
        has_no_volume: true,
        has_empty_bars: false,
        force_session_rebuild: true,
        description: "",
        has_intraday: true,
        supported_resolutions: ["1", "15", "30", "60", "1D", "1W", "1M"],
        pricescale: this.store.pricescale, //价格精度
        volume_precision: 3 //数量精度
      },
      {
        symbol: symbolName,
        ticker: symbolName,
        name: symbolName,
        pricescale: Math.pow(10, this.store.pricescale) || 8, //todo
        volume_precision: 3 || 3
      }
    );
    onSymbolResolvedCallback(newSymbol);
  }

  getBaseUrl() {
    var baseUrlHost = window.location.host;
    var hostToggle = baseUrlHost.indexOf ('localhost') >= 0 ? true : baseUrlHost.indexOf ('mitrade.com') >= 0 || baseUrlHost.indexOf ('mitradeads.com') >= 0;
    var hostName = !hostToggle ? baseUrlHost.substring (baseUrlHost.indexOf ('.') + 1) : 'mitrade.com';
    return hostName
  }

  // 获取不同时间段的历史数据
  getPeriodKlines(period,isFirst){
    if(isFirst){
      fetch(
        "https://app." + this.getBaseUrl() + "/api/v1/instruments/klines?symbol="+this.store.symbol+"&interval=" +
          period +
          "&datetime=2218-02-24T16:30:00.322348&size=-1000",
        {
          headers: {
            Locale: "en-US",
            "Session-Token": "25bf999c-4516-464a-96f7-72b6c05a7809",
            "Remember-Me-Token": "",
            "Content-Type": "text/plain;charset=UTF-8"
          }
        }
      )
        .then(response => response.json())
        .then(json => {
          let datas = [];
          let isDay = false;

          if (period === "D1" || period === "W1" || period === "MO1") {
            isDay = true;
          }
          for (let data of json.value.data) {
            datas.push({ 
              time: isDay
                ? new Date(data.datetime).getTime() * 1 +
                  3600000 * this.store.localTimezone * 2
                : new Date(data.datetime) * 1 +
                  3600000 * this.store.localTimezone,
              close: data.close,
              open: data.open,
              high: data.high,
              low: data.low
            });
          }
          this.store.lastData = datas[datas.length - 1];
          this.store.onDataCallback(datas, { noData: true });
          this.store.xhrOver = true;
          this.store.period = period;
        })
        .catch(() => {});
      }
      else{
        this.store.onDataCallback([], { noData: true });
      }
  }
}

export default DataFeeds;
